// Styles
import "../sass/main.scss";

// Images.
import "../img/graziella_sablone_logo.svg";
import "../img/cross-red.svg";
import "../img/cross-white.svg";
import "../img/made-in-luxembourg.svg";
import "../img/archilovers.svg";
import "../img/oai-logo-white.svg";
import "../img/oai-logo.svg";
import "../img/cei-creatives.png";

// Scripts
import "parsleyjs";
import "magnific-popup";
import barba from "@barba/core";
import Swiper from "swiper/bundle";
import gsap from "gsap";
import LocomotiveScroll from "locomotive-scroll";
import lozad from "lozad";
import SplitText from "./SplitText.js";
import ScrollBooster from "scrollbooster";
import BeerSlider from "beerslider";
import { createPopper } from "@popperjs/core";
import Isotope from "isotope-layout";
import "imagesloaded";

(function ($) {
  "use strict";

  window.App = {};

  App.config = {
    debug: {
      enabled: false,
    },
    cursorFollower: {
      enabled: true,
      disableBreakpoint: "992", // cursor will be disabled on this device width
    },
  };

  function debug(report1, report2 = null) {
    if (App.config.debug.enabled) {
      if (!report2) {
        console.log(report1);
      } else {
        console.log(report1, report2);
      }
    }
  }

  $.fn.BeerSlider = function (options) {
    options = options || {};
    return this.each(function () {
      new BeerSlider(this, options);
    });
  };

  var scroll;
  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };
  var headerLogo = document.querySelector(".header-logo-link");
  var mainNavigation = document.querySelector(".header-nav");
  let showMenu = false;

  barba.hooks.before(() => {
    document.querySelector("html").classList.add("is-transitioning");
  });
  barba.hooks.after(() => {
    document.querySelector("html").classList.remove("is-transitioning");
  });

  barba.init({
    sync: true,
    debug: App.config.debug.enabled,
    logLevel: "error",
    transitions: [
      {
        name: "custom-transition",
        async once({ next }) {
          // handleCustomCursor();
          await contentAnimation(next.container);
          NavigationStatments.init();
          splitTextIntoLinesMenu();
          MenuAnimation();
          CompetModalActions.init();
          Cursor.init();
          // set_current_menu_item(next);
        },
        async leave(data) {
          // On ferme le menu si il est ouvert
          if (showMenu) {
            navigationTL.reverse();
            showMenu = false;
          }
          if (showedModal) {
            competModalTL.reverse();
            showedModal = false;
          }
          await pageTransitionIn();
          data.current.container.remove();
        },
        async beforeEnter({ next }) {
          scroll.destroy();
          Cursor.clear();
          Cursor.update();
        },
        async enter({ next }) {
          NavigationStatments.reset();
          await contentAnimation(next.container);
          // set_current_menu_item(next);
        },
        afterEnter({ next }) {
          scroll.update();
          debug("afterEnter");
        },
      },
    ],
  });

  /**
   * GSAP Timelines
   */

  // Navigation

  const navigation = document.querySelector(".header-navigation");
  const close = document.querySelector(".header-navigation .close");
  const navigationContents = document.querySelectorAll(
    ".header-navigation .col-content"
  );
  const navigationMenuItems = document.querySelectorAll(
    ".header-navigation ul li"
  );

  var navigationTL;

  function MenuAnimation() {
    const navigationMenuLines = navigation.querySelectorAll(".split__line");

    navigationTL = gsap.timeline({
      paused: true,
      reversed: true,
      ease: "quart.inOut",
    });

    navigationTL.to(navigation, {
      opacity: 1,
      display: "flex",
      duration: 0.2,
    });
    navigationTL.from(navigationContents, {
      opacity: 0,
      x: 50,
      duration: 0.2,
      stagger: 0.05,
    });
    navigationTL.fromTo(
      navigationMenuLines,
      {
        y: "100%",
      },
      {
        y: "0%",
        stagger: -0.06,
        duration: 0.6,
        onStart: () => {
          // activeContent.classList.add("is-active");
        },
        onComplete: () => {
          // nav.classList.add("is-active");
        },
      },
      ">-0.2"
    );
    navigationTL.from(close, {
      opacity: 0,
      x: 15,
      duration: 0.2,
    });
  }

  /**
   * Utils
   */

  function splitTextIntoLinesMenu() {
    let target;

    target = navigation.querySelectorAll("[data-split='lines']");

    if (!target.length) return;

    target.forEach((el) => {
      // debug("el", el);
      let content;
      let test = el.querySelectorAll("* > *:not(br):not(span)");
      // debug("test", test);

      if (test.length > 0) {
        content = el.querySelectorAll("* > *:not(br):not(span)");
      }
      // debug("content", content);

      new SplitText(content, {
        type: "lines",
        linesClass: "overflow-hidden",
      });

      content.forEach((el) => {
        const lines = el.querySelectorAll(".overflow-hidden");

        new SplitText(lines, {
          type: "lines",
          linesClass: "split__line",
        });
      });

      gsap.set(el.querySelectorAll(".split__line"), {
        y: "100%",
      });
    });
  }

  function splitTextIntoLines(container) {
    let target;

    target = container.querySelectorAll("[data-split='lines']");

    if (!target.length) return;

    target.forEach((el) => {
      let content;
      let test = el.querySelectorAll("* > *:not(br):not(span)");

      if (test.length > 0) {
        content = el.querySelectorAll("* > *:not(br):not(span)");
      }

      new SplitText(content, {
        type: "lines",
        linesClass: "overflow-hidden",
      });

      content.forEach((el) => {
        const lines = el.querySelectorAll(".overflow-hidden");

        new SplitText(lines, {
          type: "lines",
          linesClass: "split__line",
        });
      });

      gsap.set(el.querySelectorAll(".split__line"), {
        y: "100%",
      });
    });
  }

  window.addEventListener("resize", get_WiewportWidth, false);
  function get_WiewportWidth() {
    debug("WPW");
    var vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    return vw;
  }

  window.addEventListener("resize", setRootVars, false);
  function setRootVars() {
    const root = document.documentElement;
    const herovh =
      Math.round(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      ) / 100;
    const mainNavvh = Math.round(mainNavigation.offsetHeight || 0);
    const logoHeadervw = Math.round(headerLogo.offsetWidth || 0);

    root.style.setProperty("--herovh", herovh + "px");
    root.style.setProperty("--mainNavvh", mainNavvh + "px");
    // root.style.setProperty("--logovw", logoHeadervw + "px");
  }
  setRootVars();

  /**
   * Fonctions
   */

  function InitBeerSlider() {
    if ($(".beer-slider").length > 0) {
      debug("InitBeerSlider");
      $(".beer-slider").each(function (index) {
        debug(index);
        $(this).BeerSlider({ start: 50 });
      });
    }
  }

  function NavMenuToggleTrigger() {
    if (!showMenu && navigationTL.reversed()) {
      navigationTL.play();
      showMenu = true;
    } else {
      navigationTL.reverse();
      showMenu = false;
    }
  }

  document.querySelectorAll(".menu-toggle").forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();
      NavMenuToggleTrigger();
    });
  });

  /**
   * Modal
   */

  // Compétences modal
  const competModal = document.querySelector(".compet-modal");
  const competModalClose = competModal.querySelector(".close");
  const competModalContents = competModal.querySelectorAll(".col-content");
  let showedModal = false;
  var competModalTL;

  const CompetModalActions = (function () {
    function init() {
      competModalTL = gsap.timeline({
        paused: true,
        reversed: true,
        ease: "quart.inOut",
      });
      competModalTL.to(competModal, {
        opacity: 1,
        display: "flex",
        duration: 0.2,
      });
      competModalTL.from(competModalContents, {
        opacity: 0,
        x: 50,
        duration: 0.2,
        stagger: 0.05,
      });
      competModalTL.from(competModalClose, {
        opacity: 0,
        x: 15,
        duration: 0.2,
      });

      close();
    }

    function open() {
      document.querySelectorAll(".modal-open").forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();

          if ("index" in event.currentTarget.dataset) {
            const serviceIndex = event.currentTarget.dataset.index;
            //debug(serviceIndex);
            Modal_get_Content(serviceIndex)
              .then((data) => {
                debug("success", data);
                // debug("success", data.title);

                const competModalTitle =
                  competModal.querySelector("#compTitle");
                const competModalContent =
                  competModal.querySelector("#compContent");
                const competModalGallery =
                  competModal.querySelector("#compGallery");

                // debug(competModalContent);
                competModalTitle.innerHTML = data.title;
                competModalContent.innerHTML = data.content;

                //const gallery = data.gallery.split(",");
                competModalGallery.innerHTML = data.gallery.join("");

                if (!showedModal && competModalTL.reversed()) {
                  competModalTL.play();
                  showedModal = true;
                }
              })
              .catch((error) => {
                debug("error", error);
              });
          }
        });
      });
    }
    function close() {
      document.querySelectorAll(".modal-close").forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          if (showedModal) {
            competModalTL.reverse();
            showedModal = false;
          }
        });
      });
    }

    function Modal_get_Content(serviceIndex) {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: ajaxurl,
          type: "POST",
          data: {
            action: "get_competences_details",
            compindex: serviceIndex,
          },
          success: function (data) {
            resolve(data);
          },
          error: function (error) {
            reject(error);
          },
        });
      });
    }

    return {
      init: init,
      open: open,
      close: close,
    };
  })();

  function MPInit() {
    $.extend(true, $.magnificPopup.defaults, {
      tClose: "Fermer (Esc)", // Alt text on close button
      tLoading: "Chargement...", // Text that is displayed during loading. Can contain %curr% and %total% keys
      gallery: {
        tPrev: "Précédent (Flèche de gauche)", // Alt text on left arrow
        tNext: "Suivant (Flèche de droite)", // Alt text on right arrow
        tCounter: "%curr% de %total%", // Markup for "1 of 7" counter
      },
      image: {
        tError: '<a href="%url%">The image</a> ne peut être chargée.', // Error message when image could not be loaded
      },
      ajax: {
        tError: '<a href="%url%">The content</a> ne peut être chargé.', // Error message when ajax request failed
      },
    });

    $(".zoom-gallery").magnificPopup({
      delegate: "a",
      type: "image",
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function (element) {
          return element.find("img");
        },
      },
    });
  }

  /**
   * Swiper Hero
   */
  const HeroMainSlider = (function () {
    let state = false;
    let sliderInstance;
    let current;

    function init() {
      const slider = document.querySelector(".js-sliderMainHero");
      if (!slider) return;

      state = true;
      const container = slider.querySelector(".swiper-container");
      const nav = slider.querySelector(".js-slider-nav");
      current = 0;
      let sliderSpeed = 1000;
      let sliderAutoplay = false;

      sliderInstance = new Swiper(container, {
        spaceBetween: 0,
        preventClicks: false,
        // preventClicksPropagation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        speed: parseInt(sliderSpeed),
        parallax: true,
        // direction: 'vertical',
        // allowTouchMove: false,
        lazy: {
          loadPrevNext: true,
        },
        // autoplay: sliderAutoplay,
        navigation: {
          prevEl: nav.querySelector(".slider__arrow_left"),
          nextEl: nav.querySelector(".slider__arrow_right"),
        },
      });
    }
    return {
      init: init,
    };
  })();

  /**
   * Swiper Projets
   */

  const ProjectSlider = (function (container) {
    let state = false;
    let sliderInstance;
    let current;

    function init(container) {
      const slider = document.querySelector(".js-sliderProject");
      // debug(slider);
      if (!slider) return;

      state = true;

      const swcontainer = slider.querySelector(".swiper-container");
      const contents = slider.querySelectorAll(".js-slider-content");
      const nav = slider.querySelector(".js-slider-nav");
      current = 0;

      let sliderSpeed = 1000;
      let sliderAutoplay = false;
      let sliderAutoplayStartDelay = 0;

      sliderInstance = new Swiper(swcontainer, {
        spaceBetween: 0,
        speed: parseInt(sliderSpeed),
        noSwiping: true,
        parallax: true,
        // direction: 'vertical',
        // allowTouchMove: false,
        allowTouchMove: false,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        lazy: {
          loadPrevNext: true,
        },
        // autoplay: sliderAutoplay,
        navigation: {
          prevEl: nav.querySelector(".slider__arrow_left"),
          nextEl: nav.querySelector(".slider__arrow_right"),
        },
        on: {
          init: function () {
            const currentContent = contents[current];
            // debug("init", currentContent);
            gsap
              .timeline()
              .set(
                [
                  currentContent.querySelectorAll(".js-subtitle .split__line"),
                  currentContent.querySelectorAll(".js-title .split__line"),
                  currentContent.querySelector(".js-desc"),
                  currentContent.querySelector(".js-button"),
                ],
                {
                  y: "0%",
                }
              )
              .set(currentContent.parentNode, {
                height: currentContent.offsetHeight,
                // delay: 2,
              });
          },
          transitionStart: function () {
            const currentContent = contents[current];
            const activeContent = contents[sliderInstance.realIndex];

            debug("transitionStart", activeContent.offsetHeight);

            gsap
              .timeline()
              .to(
                [
                  currentContent.querySelectorAll(".js-subtitle .split__line"),
                  currentContent.querySelectorAll(".js-title .split__line"),
                  currentContent.querySelector(".js-desc"),
                  currentContent.querySelector(".js-button"),
                ],
                {
                  y: "-100%",
                  stagger: 0.06,
                  duration: 0.6,
                  ease: "quart.inOut",
                  onStart: () => {
                    current = sliderInstance.realIndex;
                    currentContent.classList.remove("is-active");
                    nav.classList.remove("is-active");
                  },
                }
              )
              .fromTo(
                [
                  activeContent.querySelectorAll(".js-subtitle .split__line"),
                  activeContent.querySelectorAll(".js-title .split__line"),
                  activeContent.querySelector(".js-desc"),
                  activeContent.querySelector(".js-button"),
                ],
                {
                  y: "100%",
                },
                {
                  y: "0%",
                  stagger: -0.06,
                  duration: 0.6,
                  ease: "quart.inOut",
                  onStart: () => {
                    activeContent.classList.add("is-active");
                  },
                  onComplete: () => {
                    nav.classList.add("is-active");
                  },
                },
                ">-0.2"
              )
              .to(
                activeContent.parentNode,
                {
                  height: activeContent.offsetHeight,
                  duration: 0.3,
                  ease: "quart.inOut",
                  onComplete: () => {
                    scroll.update();
                  },
                },
                "-=0.3"
              );
          },
        },
      });

      gsap.set(slider.querySelectorAll(".js-desc"), {
        y: "100%",
      });
      gsap.set(slider.querySelectorAll(".js-button"), {
        y: "100%",
      });
    }
    function isActive() {
      return state;
    }
    return {
      init: init,
      isActive: isActive,
    };
  })();

  /**
   * Swiper Methodes
   */

  const MethodesSlider = (function () {
    let state = false;
    let sliderInstance;
    let current;

    function init() {
      const slider = document.querySelector(".js-sliderMethodes");
      if (!slider) return;

      state = true;
      const container = slider.querySelector(".swiper-container");
      const contents = slider.querySelectorAll(".js-slider-content");
      const nav = slider.querySelector(".js-slider-nav");
      current = 0;
      let sliderSpeed = 1000;
      let sliderAutoplay = false;

      sliderInstance = new Swiper(container, {
        spaceBetween: 0,
        noSwiping: true,
        allowTouchMove: false,
        // autoplay: {
        //   delay: 12000,
        //   disableOnInteraction: false,
        // },
        effect: "fade",
        autoHeight: true, //enable auto height
        fadeEffect: {
          crossFade: true,
        },
        // loop:true,
        speed: parseInt(sliderSpeed),
        parallax: true,
        // direction: 'vertical',
        // allowTouchMove: false,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          prevEl: nav.querySelector(".slider__arrow_left"),
          nextEl: nav.querySelector(".slider__arrow_right"),
        },
        on: {
          init: function () {
            const currentContent = contents[current];
            // debug("init", currentContent);
            gsap
              .timeline()
              .set(
                [
                  currentContent.querySelectorAll(".js-title .split__line"),
                  currentContent.querySelector(".js-desc"),
                ],
                {
                  y: "0%",
                }
              );
          },
          transitionStart: function () {
            const currentContent = contents[current];
            const activeContent = contents[sliderInstance.realIndex];

            // debug("transitionStart", activeContent);
            gsap
              .timeline()
              .to(
                [
                  currentContent.querySelectorAll(".js-title .split__line"),
                  currentContent.querySelector(".js-desc"),
                ],
                {
                  y: "-100%",
                  stagger: 0.06,
                  duration: 0.6,
                  ease: "quart.inOut",
                  onStart: () => {
                    current = sliderInstance.realIndex;
                    currentContent.classList.remove("is-active");
                    nav.classList.remove("is-active");
                  },
                }
              )
              .fromTo(
                [
                  activeContent.querySelectorAll(".js-title .split__line"),
                  activeContent.querySelector(".js-desc"),
                ],
                {
                  y: "100%",
                },
                {
                  y: "0%",
                  stagger: -0.06,
                  duration: 0.6,
                  ease: "quart.inOut",
                  onStart: () => {
                    activeContent.classList.add("is-active");
                  },
                  onComplete: () => {
                    nav.classList.add("is-active");
                  },
                },
                ">-0.2"
              );
          },
          transitionEnd: function () {
            scroll.update();
          },
        },
        // autoplay: sliderAutoplay,
        // navigation: {
        //   prevEl: nav.querySelector(".js-prev"),
        //   nextEl: nav.querySelector(".js-next"),
        // },
      });
      gsap.set(slider.querySelectorAll(".js-desc"), {
        y: "100%",
      });
    }
    return {
      init: init,
    };
  })();

  const NavigationStatments = (function () {
    let state = false;
    let sticked = false;
    let scrollState = 0;
    var heroOffsetHeight = 0;

    function get_HeroHeight() {
      var OffsetHeight = document.querySelector(".hero-header").offsetHeight;
      heroOffsetHeight = OffsetHeight;
      // debug("get_HeroHeight", heroOffsetHeight);
      return OffsetHeight;
    }

    function init() {
      mainNavigation.style.removeProperty("bottom");
      heroOffsetHeight = get_HeroHeight();
      window.addEventListener("resize", get_HeroHeight, false);
      // debug("init", [scrollState, heroOffsetHeight]);
    }
    function scrolling(scroll_y) {
      const headerInner = document.querySelector(".hero-header-inner");

      scrollState = scroll_y;

      debug([scroll_y, heroOffsetHeight]);

      headerInner.style.top = scroll_y + "px";

      if (!sticked) {
        // debug([datas.scroll.y, heroOffsetHeight]);
        mainNavigation.style.bottom = scroll_y + "px";
      } else {
        mainNavigation.style.removeProperty("bottom");
      }

      // Ajouter le shadow au menu si on scroll
      if (scroll_y && heroOffsetHeight) {
        if (scroll_y >= heroOffsetHeight) {
          if (!sticked) {
            debug("mainNavigation", "Fixed!");
            mainNavigation.classList.add("is-fixed");
            sticked = true;
          }
        } else if (sticked) {
          debug("mainNavigation", "Not Fixed!");
          mainNavigation.classList.remove("is-fixed");
          sticked = false;
        }
      }
    }

    function reset() {
      debug("reset", [scrollState, heroOffsetHeight]);

      var resetBottomPosition = heroOffsetHeight;

      const navtimeline = gsap.timeline({ ease: "quart.inOut" });

      navtimeline.set(mainNavigation, {
        position: "absolute",
        bottom: 0,
        top: "inherit",
        y: 10,
      });
      navtimeline.to(mainNavigation, {
        opacity: 1,
        duration: 1,
        y: 0,
        delay: 0.2,
      });

      if (sticked) {
        navtimeline.eventCallback("onComplete", function () {
          mainNavigation.classList.remove("is-fixed");
          mainNavigation.style.removeProperty("top");
          sticked = false;
        });
      }
    }
    return {
      init: init,
      scrolling: scrolling,
      reset: reset,
    };
  })();

  const animCatHero = (function () {
    function init() {
      const hero = document.querySelector(".js-sliderCatHero");
      if (!hero) return;

      const catItems = document.querySelectorAll(".cat-item--content");
      // const catImagesWrapper = document.querySelector(".cat-img");
      const catImages = document.querySelectorAll(".cat-img-item");

      debug(catItems);

      for (let i = 0; i < catItems.length; i++) {
        catItems[i].addEventListener("mouseenter", function (event) {
          event.stopPropagation();
          event.cancelBubble = true;

          const bgtl = gsap.timeline({ ease: "quart.inOut" });
          bgtl.to(catImages, {
            autoAlpha: 0,
            duration: 0.5,
          });
          bgtl.to(
            document.getElementById(event.target.dataset.cat),
            { autoAlpha: 1, duration: 0.5 },
            "-=.5"
          );

          const cattl = gsap.timeline({ ease: "quart.inOut" });
          cattl.to(catItems, {
            opacity: 0.5,
            duration: 0.5,
            color: "#000",
          });
          cattl.to(
            document.getElementById("cat-" + event.target.dataset.cat),
            { opacity: 1, color: "#fff", duration: 0.5 },
            "-=.5"
          );
        });
      }
    }
    return {
      init: init,
    };
  })();

  const heroScrollBoost = (function () {
    function init() {
      const hero = document.querySelector(".js-scrollboost");
      if (!hero) return;

      const viewport = document.querySelector(".viewport");
      const content = document.querySelector(".spots-content");
      const imageSpotWrapper = document.querySelector(".image-spot");
      const image = document.querySelector(".spots-image");

      $(".image-spot").imagesLoaded(function () {
        const sb = new ScrollBooster({
          viewport,
          content,
          scrollMode: "transform",
          bounce: false,
          textSelection: true,
          // emulateScroll: true,
          onUpdate: (state) => {
            debug("onUpdate", [state.position.x, state.position.y]);
          },
        });

        const offsetX = image.scrollWidth - viewport.offsetWidth;
        const offsetY = image.scrollHeight - viewport.offsetHeight;
        sb.setPosition({
          x: offsetX / 2,
          y: offsetY / 2,
        });

        debug("heroScrollBoost", [image.scrollWidth, viewport.offsetWidth]);
        debug("heroScrollBoost", imageSpotWrapper);

        imageSpotWrapper.setAttribute(
          "style",
          "width:" +
            image.scrollWidth +
            "px; height:" +
            image.scrollHeight +
            "px"
        );

        debug("heroScrollBoost", imageSpotWrapper);

        window.addEventListener("resize", () => {
          imageSpotWrapper.setAttribute(
            "style",
            "width:" +
              image.scrollWidth +
              "px; height:" +
              image.scrollHeight +
              "px"
          );
          debug("heroScrollBoost", imageSpotWrapper);
        });

        heroSpotlights.init();
      });
    }
    return {
      init: init,
    };
  })();

  const heroSpotlights = (function () {
    function init() {
      const hero = document.querySelector(".js-scrollboost");
      if (!hero) return;

      // images have loaded

      debug("heroSpotlights");

      const tooltips = document.querySelectorAll(".spot");

      tooltips.forEach((tooltip) => {
        const button = tooltip.querySelector(".tooltip-button");
        const container = tooltip.querySelector(".tooltip-containaer");

        debug("createPopper", button);

        const popperInstance = createPopper(button, container, {
          placement: "right",
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 20],
              },
            },
          ],
        });

        function show() {
          // Make the tooltip visible
          container.setAttribute("data-show", "");

          // Enable the event listeners
          popperInstance.setOptions({
            modifiers: [{ name: "eventListeners", enabled: true }],
          });

          // Update its position
          popperInstance.update();
        }

        function hide() {
          // Hide the tooltip
          container.removeAttribute("data-show");

          // Disable the event listeners
          popperInstance.setOptions({
            modifiers: [{ name: "eventListeners", enabled: false }],
          });
        }

        const showEvents = ["mouseenter", "focus"];
        const hideEvents = ["mouseleave", "blur"];

        showEvents.forEach((event) => {
          button.addEventListener(event, show);
        });

        hideEvents.forEach((event) => {
          button.addEventListener(event, hide);
        });
      });

      setTimeout(function () {
        console.log("BAAAAM 3sec");
      }, 3000);

      // debug([offsetX, offsetY]);
    }
    return {
      init: init,
    };
  })();

  const isotopeProjects = (function () {
    let isoInstance;

    function init() {
      var grid = document.querySelector(".grid");
      if (!grid) return;

      var buttonGroups = document.querySelectorAll(".button-group");

      isoInstance = new Isotope(grid, {
        // options...
        itemSelector: ".grid-item",
        percentPosition: true,
        // layoutMode: "fitRows",
        masonry: {
          columnWidth: ".grid-sizer",
        },
      });

      isoInstance.on("arrangeComplete", function (filteredItems) {
        observer.observe();
        scroll.update();
      });

      var filtersElem = document.querySelector(".filters-button-group");
      if (filtersElem) {
        filtersElem.addEventListener("click", function (event) {
          var filterValue = event.target.getAttribute("data-filter");
          isoInstance.arrange({ filter: filterValue });
        });
      }

      var heroFiltersElem = document.querySelectorAll(".cat-item--content");
      for (let i = 0; i < heroFiltersElem.length; i++) {
        heroFiltersElem[i].addEventListener("click", function (event) {
          event.stopPropagation();
          event.cancelBubble = true;

          for (var y = 0, len = buttonGroups.length; y < len; y++) {
            var buttonGroup = buttonGroups[y];
            buttonGroup.querySelector(".active").classList.remove("active");
            var elements = buttonGroup.children;
            // console.log(elements.item(i + 1));
            elements.item(i + 1).classList.add("active");
          }

          var filterValue = event.currentTarget.getAttribute("data-filter");

          setTimeout(function () {
            // debug(filterValue);
            scroll.scrollTo(filtersElem.parentNode);
            setTimeout(function () {
              isoInstance.arrange({ filter: filterValue });
            }, 50);
          }, 500);
        });
      }

      for (var i = 0, len = buttonGroups.length; i < len; i++) {
        var buttonGroup = buttonGroups[i];
        radioButtonGroup(buttonGroup);
      }

      function radioButtonGroup(buttonGroup) {
        buttonGroup.addEventListener("click", function (event) {
          // console.log("oups");
          // only work with buttons

          buttonGroup.querySelector(".active").classList.remove("active");
          event.target.classList.add("active");
        });
      }

      // debug("isotopeProjects");
    }

    function update() {
      isoInstance.layout();
    }
    function destroy() {
      isoInstance.destroy();
    }

    return {
      init: init,
      update: update,
      destroy: destroy,
    };
  })();

  /**
   * Lozad
   */
  const observer = lozad(".lozad", {
    loaded: function (el) {
      // Custom implementation on a loaded element
      if (scroll !== undefined) {
        // scroll.update();
      }
    },
  });

  /**
   * Locomotive Scroll
   */
  function smooth(container) {
    debug("smooth");
    var sticked = false;
    var sscroll = container.querySelector("[data-scroll-container]");
    scroll = new LocomotiveScroll({
      el: sscroll,
      smooth: true,
      repeat: true,
      getDirection: true,
      reloadOnContextChange: true,
      // lerp: 0.5,
      smartphone: {
        smooth: true,
      },
      tablet: {
        smooth: true,
      },
    });

    scroll.on("scroll", function (datas) {
      NavigationStatments.scrolling(datas.scroll.y);
    });
  }

  function set_current_menu_item(next) {
    var menu = document.querySelector(".menu");
    var nextItem = menu.querySelector(`a[href="${next.url.href}"]`);
    debug(next);

    var activeItems = menu.querySelector(".item-active");
    if (activeItems !== null) {
      activeItems.classList.remove("item-active");
    }
    if (nextItem !== null) {
      nextItem.classList.add("item-active");
    }
  }

  function pageTransitionIn() {
    // scroll.scrollTo("top", 0, 200);
    var transition;
    // debug("desktop", get_WiewportWidth());
    transition = gsap
      .timeline({ ease: "quart.inOut" })
      .to(document.querySelector(".is-animated"), {
        duration: 0.4,
        translateY: 10,
        opacity: 0,
        stagger: 0.4,
        // delay: 0.5,
      })
      .to(
        mainNavigation,
        {
          opacity: 0,
          y: 10,
          duration: 0.4,
        },
        "-=.2"
      );

    // Scroll to top
    return transition;
  }

  function contentAnimation(container) {
    convertSVG();
    splitTextIntoLines(container);
    HeroMainSlider.init();
    ProjectSlider.init(container);
    MethodesSlider.init();
    animCatHero.init();
    isotopeProjects.init();
    InitBeerSlider();
    // CompetModalToggle();
    CompetModalActions.open();
    heroScrollBoost.init();

    MPInit();

    smooth(container);
    observer.observe();

    return gsap
      .timeline({ ease: "quart.inOut" })
      .from(container.querySelector(".is-animated"), {
        duration: 1,
        translateY: 10,
        opacity: 0,
        stagger: 0.4,
      })
      .from([document.querySelectorAll(".hero-bottom .is-animated")], {
        duration: 1,
        translateY: 10,
        opacity: 0,
        stagger: 0.4,
      })
      .call(function () {
        // Init_Swiper();

        InitFuncFormContact();
      });
  }

  function convertSVG() {
    jQuery("img.svg").each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");

      jQuery.get(imgURL, function (data) {
        var $svg = jQuery(data).find("svg");

        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        $svg = $svg.removeAttr("width");
        $svg = $svg.removeAttr("height");

        $img.replaceWith($svg);
      });
    });
  }

  function InitFuncFormContact() {
    jQuery("#contact-form").parsley();
    jQuery("#contact-form").on("submit", function (e) {
      e.preventDefault();
      scroll.update();
      var t = jQuery(this),
        o = t.find("#valid-form");
      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          jQuery.ajax({
            url: ajaxurl,
            data: jQuery(this).serialize(),
            type: "POST",
            success: function (e) {
              debug(e),
                jQuery(".fields").fadeOut(200),
                setTimeout(function () {
                  jQuery(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  jQuery(".messages").fadeIn();
                  scroll.update();
                }, 300);
            },
            error: function (e) {
              debug(e);
              jQuery(".fields").fadeOut(200),
                setTimeout(function () {
                  jQuery(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  jQuery(".sub_error").css("opacity", "1");
                  scroll.update();
                }, 300);
            },
          });
    });

    window.Parsley.on("form:validated", function () {
      // This global callback will be called for any field that fails validation.
      scroll.update();
    });
  }

  const Cursor = (function () {
    const cursor = document.querySelector(".js-cursor");
    let follower;
    let label;
    let icon;

    let clientX;
    let clientY;
    let cursorWidth;
    let cursorHeight;
    let cursorTriggers;
    let state;

    function variables() {
      follower = cursor.querySelector(".js-follower");
      label = cursor.querySelector(".js-label");
      icon = cursor.querySelector(".js-icon");

      clientX = -100;
      clientY = -100;
      cursorWidth = cursor.offsetWidth / 2;
      cursorHeight = cursor.offsetHeight / 2;
      cursorTriggers;
      state = false;
    }

    function init() {
      if (!cursor) return;

      variables();
      state = true;
      cursor.classList.add("is-enabled");

      document.addEventListener("mousedown", (e) => {
        cursor.classList.add("is-mouse-down");
      });

      document.addEventListener("mouseup", (e) => {
        cursor.classList.remove("is-mouse-down");
      });

      document.addEventListener("mousemove", (event) => {
        clientX = event.clientX;
        clientY = event.clientY;
      });

      const render = () => {
        cursor.style.transform = `translate(${clientX - cursorWidth}px, ${
          clientY - cursorHeight
        }px)`;
        requestAnimationFrame(render);
      };

      requestAnimationFrame(render);

      update();
      breakpoint();
    }

    function enterHandler({ target }) {
      cursor.classList.add("is-active");

      if (target.getAttribute("data-cursor-label")) {
        App.body.classList.add("is-cursor-active");
        cursor.classList.add("has-label");
        label.innerHTML = target.getAttribute("data-cursor-label");
      }

      if (target.getAttribute("data-cursor-icon")) {
        App.body.classList.add("is-cursor-active");
        cursor.classList.add("has-icon");
        const iconAttr = target.getAttribute("data-cursor-icon");
        icon.innerHTML = feather.icons[iconAttr].toSvg();
      }
    }

    function leaveHandler({ target }) {
      document.body.classList.remove("is-cursor-active");
      cursor.classList.remove("is-active");
      cursor.classList.remove("has-label");
      cursor.classList.remove("has-icon");
      label.innerHTML = "";
      icon.innerHTML = "";
    }

    function update() {
      if (!cursor) return;

      cursorTriggers = document.querySelectorAll([
        "button",
        "a",
        "input",
        "[data-cursor]",
        "[data-cursor-label]",
        "[data-cursor-icon]",
        "textarea",
      ]);

      cursorTriggers.forEach((el) => {
        el.addEventListener("mouseenter", enterHandler);
        el.addEventListener("mouseleave", leaveHandler);
      });
    }

    function clear() {
      if (!cursor) return;

      cursorTriggers.forEach((el) => {
        el.removeEventListener("mouseenter", enterHandler);
        el.removeEventListener("mouseleave", leaveHandler);
      });
    }

    function hide() {
      if (!cursor) return;
      cursor.classList.add("is-hidden");
    }

    function show() {
      if (!cursor) return;
      cursor.classList.remove("is-hidden");
    }

    function breakpoint() {
      if (!state) return;
      // if (!App.config.cursorFollower.disableBreakpoint) return;

      let width = window.innerWidth > 0 ? window.innerWidth : screen.width;

      if (width < App.config.cursorFollower.disableBreakpoint) {
        state = false;
        cursor.classList.remove("is-enabled");
        clear();
      } else {
        state = true;
        cursor.classList.add("is-enabled");
        update();
      }

      window.addEventListener("resize", () => {
        let width = window.innerWidth > 0 ? window.innerWidth : screen.width;

        if (width < App.config.cursorFollower.disableBreakpoint) {
          state = false;
          cursor.classList.remove("is-enabled");
          clear();
        } else {
          state = true;
          cursor.classList.add("is-enabled");
          update();
        }
      });
    }

    return {
      init: init,
      update: update,
      clear: clear,
      hide: hide,
      show: show,
    };
  })();

  Parsley.addMessages("fr", {
    defaultMessage: "Cette valeur semble non valide.",
    type: {
      email: "Cette valeur n'est pas une adresse email valide.",
      url: "Cette valeur n'est pas une URL valide.",
      number: "Cette valeur doit être un nombre.",
      integer: "Cette valeur doit être un entier.",
      digits: "Cette valeur doit être numérique.",
      alphanum: "Cette valeur doit être alphanumérique.",
    },
    notblank: "Cette valeur ne peut pas être vide.",
    required: "Ce champ est requis.",
    pattern: "Cette valeur semble non valide.",
    min: "Cette valeur ne doit pas être inférieure Ã  %s.",
    max: "Cette valeur ne doit pas excéder %s.",
    range: "Cette valeur doit être comprise entre %s et %s.",
    minlength:
      "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
    maxlength:
      "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
    length: "Cette valeur doit contenir entre %s et %s caractères.",
    mincheck: "Vous devez sélectionner au moins %s choix.",
    maxcheck: "Vous devez sélectionner %s choix maximum.",
    check: "Vous devez sélectionner entre %s et %s choix.",
    equalto: "Cette valeur devrait être identique.",
  });

  Parsley.setLocale("fr");
})(jQuery);
